import React, { useState, useEffect } from "react";
import { 
  Button, TextField, Grid, Typography, Box, Card, CardContent, 
  Dialog, DialogActions, DialogContent, DialogTitle, IconButton,
  Chip, Avatar, FormControl, InputLabel, Select, MenuItem, Slide,
  Collapse, Divider, Tooltip, Badge, ListItemIcon, CircularProgress,
  Menu, Paper, Stack, InputAdornment, alpha, Fade, Zoom, styled, useTheme,
  LinearProgress, Alert, AlertTitle, Container,FormControlLabel,Checkbox
} from "@mui/material";
import {
  Business, Phone, ExpandMore, ReceiptLong, DeleteOutline,
  Person, Category, ShoppingBasket, Receipt, FlashOn,
  LocalShipping, MoreHoriz, AccountBalance, Edit, AddCircle,
  Add, Close, ArrowBack, ImportExport, CloseRounded, Stop, PlayArrow,
  Store, Inventory, AttachMoney, Search, FilterList,
  Refresh, Download, Print, Share, CheckCircle, Warning,
  Info, Star, StarBorder, TrendingUp, Assessment,
  CalendarToday, Payment, CreditCard, MoneyOff,
  Save, Cancel, DeleteForever, EditNote, LocationOn
} from '@mui/icons-material';
import { motion, AnimatePresence } from "framer-motion";
import Fournisseur from '../Services/Fournisseur';
import Facture from '../Services/FactureFournisseur';
import ExcelTableFournisseur from "../Components/Tables/ExcelTableFrounisseur";


// Animation variants
const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 }
};

const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.1
    }
  }
};

// Styled Components
const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: '24px',
  background: '#FFFFFF',
  boxShadow: '0 8px 24px rgba(0,0,0,0.05)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  position: 'relative',
  overflow: 'hidden',
  '&:hover': {
    transform: 'translateY(-6px)',
    boxShadow: '0 20px 30px rgba(0,0,0,0.1)',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    opacity: 0,
    transition: 'opacity 0.3s ease',
  },
  '&:hover::before': {
    opacity: 1,
  }
}));

const MetricCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2.5),
  borderRadius: '16px',
  background: '#FFFFFF',
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
  }
}));

const StatIconWrapper = styled(Avatar)(({ theme, color }) => ({
  width: 48,
  height: 48,
  background: `linear-gradient(135deg, ${color || theme.palette.primary.main}, ${alpha(color || theme.palette.primary.main, 0.7)})`,
  boxShadow: `0 8px 16px ${alpha(color || theme.palette.primary.main, 0.3)}`,
  color: 'white',
}));

const FournisseurPage = () => {
  const theme = useTheme();
  const [nomFournisseur, setNomFournisseur] = useState("");
  const [numeroFournisseur, setNumeroFournisseur] = useState("");
  const [addressFournisseur, setAddressFournisseur] = useState("");
  const [taxIdFournisseur, setTaxIdFournisseur] = useState("");
  const [paymentTermsFournisseur, setPaymentTermsFournisseur] = useState("30_days");
  const [idFactureSelectionnee, setIdFactureSelectionnee] = useState(null);
  const [factures, setFactures] = useState([]);
  const [fournisseurs, setFournisseurs] = useState([]);
  const [idFournisseurSelectionne, setIdFournisseurSelectionne] = useState(null);
  const [dialogueFournisseurOuvert, setDialogueFournisseurOuvert] = useState(false);
  const [fournisseurDeveloppe, setFournisseurDeveloppe] = useState(null);
  const [afficherFactures, setAfficherFactures] = useState(false);
  const [chargement, setChargement] = useState(false);
  const [chargementFactures, setChargementFactures] = useState(false);
  const [rafraichissementAuto, setRafraichissementAuto] = useState(false);
  const idRestaurant = localStorage.getItem("restaurantId");
  const [anchorEl, setAnchorEl] = useState(null);
  const [fournisseurEnEdition, setFournisseurEnEdition] = useState(null);
  const [modeEdition, setModeEdition] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [hoveredCard, setHoveredCard] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState({ open: false, id: null, name: '' });

  // Statistiques
  const [stats, setStats] = useState({
    totalFournisseurs: 0,
    totalFactures: 0,
    totalMontant: 0,
    totalPaye: 0,
    totalReste: 0
  });

  // Récupération des données
  const recupererFournisseurs = async () => {
    setChargement(true);
    try {
      const listeFournisseurs = await Fournisseur.getAllFournisseurs(idRestaurant);
      
      // Pour chaque fournisseur, récupérer ses factures
      const fournisseursAvecFactures = await Promise.all(
        listeFournisseurs.map(async (fournisseur) => {
          try {
            const facturesFournisseur = await Facture.getFacturesByFournisseurId(fournisseur.id, idRestaurant);
            const totalMontant = facturesFournisseur.reduce((sum, f) => sum + (parseFloat(f.achatTTC) || 0), 0);
            const totalPaye = facturesFournisseur.reduce((sum, f) => sum + (parseFloat(f.montantPaye) || 0), 0);
            const totalReste = facturesFournisseur.reduce((sum, f) => sum + (parseFloat(f.resteAPayer) || 0), 0);
            
            return {
              ...fournisseur,
              factures: facturesFournisseur,
              facturesCount: facturesFournisseur.length,
              totalMontant,
              totalPaye,
              totalReste
            };
          } catch (error) {
            console.error(`Erreur pour le fournisseur ${fournisseur.id}:`, error);
            return {
              ...fournisseur,
              factures: [],
              facturesCount: 0,
              totalMontant: 0,
              totalPaye: 0,
              totalReste: 0
            };
          }
        })
      );
      
      setFournisseurs(fournisseursAvecFactures);
      
      // Calculer les statistiques globales
      const totalFactures = fournisseursAvecFactures.reduce((acc, f) => acc + f.facturesCount, 0);
      const totalMontant = fournisseursAvecFactures.reduce((acc, f) => acc + f.totalMontant, 0);
      const totalPaye = fournisseursAvecFactures.reduce((acc, f) => acc + f.totalPaye, 0);
      const totalReste = fournisseursAvecFactures.reduce((acc, f) => acc + f.totalReste, 0);
      
      setStats({
        totalFournisseurs: fournisseursAvecFactures.length,
        totalFactures,
        totalMontant,
        totalPaye,
        totalReste
      });
      
    } catch (erreur) {
      console.error("Erreur lors de la récupération des fournisseurs:", erreur);
    } finally {
      setChargement(false);
    }
  };

  const ajouterFournisseur = async () => {
    try {
      const fournisseurData = {
        name: nomFournisseur,
        numero: numeroFournisseur,
        address: addressFournisseur,
        taxId: taxIdFournisseur,
        paymentTerms: paymentTermsFournisseur,
        restaurantId: idRestaurant
      };
      
      await Fournisseur.addFournisseur(idRestaurant, fournisseurData);
      reinitialiserFormulaireFournisseur();
      recupererFournisseurs();
    } catch (erreur) {
      console.error("Erreur lors de l'ajout du fournisseur:", erreur);
    }
  };

  const modifierFournisseur = async () => {
    try {
      const fournisseurData = {
        name: nomFournisseur,
        numero: numeroFournisseur,
        address: addressFournisseur,
        taxId: taxIdFournisseur,
        paymentTerms: paymentTermsFournisseur,
        restaurantId: idRestaurant
      };
      
      await Fournisseur.updateFournisseur(idRestaurant, fournisseurEnEdition.id, fournisseurData);
      reinitialiserFormulaireFournisseur();
      recupererFournisseurs();
    } catch (erreur) {
      console.error("Erreur lors de la modification du fournisseur:", erreur);
    }
  };

  const supprimerFournisseur = async () => {
    try {
      await Fournisseur.deleteFournisseur(idRestaurant, deleteDialog.id);
      setDeleteDialog({ open: false, id: null, name: '' });
      recupererFournisseurs();
    } catch (erreur) {
      console.error("Erreur lors de la suppression du fournisseur:", erreur);
    }
  };

  const recupererFactures = async (idFournisseur) => {
    setChargementFactures(true);
    try {
      const listeFactures = await Facture.getFacturesByFournisseurId(idFournisseur, idRestaurant);
      setFactures(listeFactures);
    } catch (erreur) {
      console.error("Erreur lors de la récupération des factures:", erreur);
    } finally {
      setChargementFactures(false);
    }
  };

  useEffect(() => {
    if (idRestaurant) {
      recupererFournisseurs();
    }
    let intervalId;
    
    if (rafraichissementAuto) {
      intervalId = setInterval(() => {
        recupererFournisseurs();
      }, 5000);
    }
    
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [rafraichissementAuto, idRestaurant]);

  const reinitialiserFormulaireFournisseur = () => {
    setNomFournisseur("");
    setNumeroFournisseur("");
    setAddressFournisseur("");
    setTaxIdFournisseur("");
    setPaymentTermsFournisseur("30_days");
    setDialogueFournisseurOuvert(false);
    setFournisseurEnEdition(null);
    setModeEdition(false);
  };

  const handleMenuOpen = (event, fournisseur) => {
    setAnchorEl(event.currentTarget);
    setFournisseurEnEdition(fournisseur);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const preparerEditionFournisseur = (fournisseur) => {
    setNomFournisseur(fournisseur.name);
    setNumeroFournisseur(fournisseur.numero);
    setAddressFournisseur(fournisseur.address || "");
    setTaxIdFournisseur(fournisseur.taxId || "");
    setPaymentTermsFournisseur(fournisseur.paymentTerms || "30_days");
    
    setDialogueFournisseurOuvert(true);
    setFournisseurEnEdition(fournisseur);
    setModeEdition(true);
    handleMenuClose();
  };

  const genererCouleurDepuisChaine = (chaine) => {
    let hash = 0;
    for (let i = 0; i < chaine.length; i++) {
      hash = chaine.charCodeAt(i) + ((hash << 5) - hash);
    }
    return `hsl(${hash % 360}, 70%, 45%)`;
  };

  const basculerRafraichissementAuto = () => setRafraichissementAuto(!rafraichissementAuto);

  const handleSubmitFournisseur = () => {
    if (modeEdition) {
      modifierFournisseur();
    } else {
      ajouterFournisseur();
    }
  };

  const filteredFournisseurs = fournisseurs.filter(f => 
    f.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    f.numero?.includes(searchTerm)
  );

  const formatNumber = (num) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'TND',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num || 0);
  };

  return (
    <Box sx={{ 
      p: 4, 
      background: 'linear-gradient(145deg, #F5F7FA 0%, #E8ECF0 100%)',
      minHeight: '100vh',
      position: 'relative',
      overflowX: 'hidden'
    }}>
      {/* Background Decoration */}
      <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'radial-gradient(circle at 50% 50%, rgba(33,150,243,0.03) 0%, transparent 50%)',
        pointerEvents: 'none',
        zIndex: 0
      }} />

      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
        <motion.div
          initial="initial"
          animate="animate"
          variants={staggerContainer}
        >
          {/* Hero Section */}
          <motion.div variants={fadeInUp}>
            <Paper
              elevation={0}
              sx={{
                mb: 4,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: 4,
                border: '1px solid rgba(255,255,255,0.1)',
                overflow: 'hidden',
                position: 'relative',
                '&::before': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: '-100%',
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0) 100%)',
                  transition: 'left 0.6s',
                },
                '&:hover::before': {
                  left: '100%'
                }
              }}
            >
              <Box sx={{ p: 4 }}>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between',
                  flexDirection: { xs: 'column', sm: 'row' },
                  gap: { xs: 2, sm: 0 }
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                    <Zoom in={true} style={{ transitionDelay: '200ms' }}>
                      <Avatar
                        sx={{
                          width: 80,
                          height: 80,
                          background: 'linear-gradient(135deg, #FFD700, #FFA500)',
                          boxShadow: '0 10px 20px rgba(255,215,0,0.3)',
                        }}
                      >
                        <Business sx={{ fontSize: 48, color: '#1E2A3A' }} />
                      </Avatar>
                    </Zoom>
                    <Box>
                      <Typography 
                        variant="h3" 
                        sx={{ 
                          fontWeight: 800,
                          background: 'linear-gradient(45deg, #FFFFFF 30%, #FFD700 90%)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          mb: 1,
                        }}
                      >
                        Gestion des Fournisseurs
                      </Typography>
                      <Typography variant="h6" sx={{ color: 'rgba(255,255,255,0.8)', fontWeight: 400 }}>
                        {stats.totalFournisseurs} fournisseurs • {stats.totalFactures} factures
                      </Typography>
                    </Box>
                  </Box>
                  
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <Tooltip title="Rafraîchir" arrow>
                      <IconButton 
                        onClick={recupererFournisseurs}
                        sx={{ color: 'white', '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
                      >
                        <Refresh />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={rafraichissementAuto ? "Désactiver auto-refresh" : "Activer auto-refresh"} arrow>
                      <IconButton 
                        onClick={basculerRafraichissementAuto}
                        sx={{ 
                          color: 'white', 
                          '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
                          animation: rafraichissementAuto ? 'pulse 2s infinite' : 'none'
                        }}
                      >
                        {rafraichissementAuto ? <Stop /> : <PlayArrow />}
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </motion.div>

          {/* Stats Cards */}
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} sm={6} md={4}>
              <motion.div variants={fadeInUp}>
                <MetricCard
                  onMouseEnter={() => setHoveredCard('total')}
                  onMouseLeave={() => setHoveredCard(null)}
                  sx={{
                    transform: hoveredCard === 'total' ? 'translateY(-4px)' : 'none',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <StatIconWrapper color="#667eea">
                      <Business />
                    </StatIconWrapper>
                    <Box>
                      <Typography variant="body2" sx={{ color: '#5F6B7A' }}>
                        Total Fournisseurs
                      </Typography>
                      <Typography variant="h4" sx={{ fontWeight: 700, color: '#1A2B3C' }}>
                        {stats.totalFournisseurs}
                      </Typography>
                    </Box>
                  </Box>
                </MetricCard>
              </motion.div>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <motion.div variants={fadeInUp}>
                <MetricCard
                  onMouseEnter={() => setHoveredCard('factures')}
                  onMouseLeave={() => setHoveredCard(null)}
                  sx={{
                    transform: hoveredCard === 'factures' ? 'translateY(-4px)' : 'none',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <StatIconWrapper color="#FF9800">
                      <ReceiptLong />
                    </StatIconWrapper>
                    <Box>
                      <Typography variant="body2" sx={{ color: '#5F6B7A' }}>
                        Total Factures
                      </Typography>
                      <Typography variant="h4" sx={{ fontWeight: 700, color: '#1A2B3C' }}>
                        {stats.totalFactures}
                      </Typography>
                    </Box>
                  </Box>
                </MetricCard>
              </motion.div>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <motion.div variants={fadeInUp}>
                <MetricCard
                  onMouseEnter={() => setHoveredCard('montant')}
                  onMouseLeave={() => setHoveredCard(null)}
                  sx={{
                    transform: hoveredCard === 'montant' ? 'translateY(-4px)' : 'none',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <StatIconWrapper color="#2196F3">
                      <AttachMoney />
                    </StatIconWrapper>
                    <Box>
                      <Typography variant="body2" sx={{ color: '#5F6B7A' }}>
                        Montant Total
                      </Typography>
                      <Typography variant="h5" sx={{ fontWeight: 700, color: '#1A2B3C' }}>
                        {formatNumber(stats.totalMontant)}
                      </Typography>
                    </Box>
                  </Box>
                </MetricCard>
              </motion.div>
            </Grid>
          </Grid>

          {/* Search and Actions */}
          <motion.div variants={fadeInUp}>
            <Paper sx={{ 
              p: 3, 
              mb: 4, 
              borderRadius: 3,
              background: '#FFFFFF',
              border: '1px solid #E0E0E0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: 2
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
                <TextField
                  placeholder="Rechercher un fournisseur..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search sx={{ color: '#9AA6B2' }} />
                      </InputAdornment>
                    ),
                    sx: {
                      bgcolor: '#F5F7FA',
                      borderRadius: 2,
                      width: { xs: '100%', sm: 300 },
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#E0E0E0'
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#667eea'
                      }
                    }
                  }}
                />
                <Chip
                  icon={<FilterList />}
                  label={`${filteredFournisseurs.length} résultats`}
                  sx={{ bgcolor: alpha('#667eea', 0.1), color: '#667eea' }}
                />
              </Box>

              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => {
                  reinitialiserFormulaireFournisseur();
                  setDialogueFournisseurOuvert(true);
                }}
                sx={{
                  py: 1.5,
                  px: 3,
                  background: 'linear-gradient(45deg, #667eea, #764ba2)',
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 600,
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 10px 20px rgba(102,126,234,0.3)'
                  }
                }}
              >
                Nouveau Fournisseur
              </Button>
            </Paper>
          </motion.div>

          {/* Fournisseurs Grid */}
          {chargement ? (
            <Box sx={{ width: '100%', py: 4 }}>
              <LinearProgress sx={{ borderRadius: 1 }} />
            </Box>
          ) : filteredFournisseurs.length === 0 ? (
            <Fade in={true}>
              <Paper sx={{ p: 6, textAlign: 'center', borderRadius: 4 }}>
                <Business sx={{ fontSize: 80, color: '#B0BEC5', mb: 2 }} />
                <Typography variant="h5" sx={{ color: '#5F6B7A', mb: 1 }}>
                  Aucun fournisseur trouvé
                </Typography>
                <Typography variant="body2" sx={{ color: '#9AA6B2', mb: 3 }}>
                  {searchTerm ? 'Essayez de modifier votre recherche' : 'Commencez par ajouter un fournisseur'}
                </Typography>
                <Button
                  variant="contained"
                  startIcon={<Add />}
                  onClick={() => {
                    reinitialiserFormulaireFournisseur();
                    setDialogueFournisseurOuvert(true);
                  }}
                  sx={{ borderRadius: 2 }}
                >
                  Ajouter un fournisseur
                </Button>
              </Paper>
            </Fade>
          ) : (
            <Grid container spacing={3}>
              <AnimatePresence>
                {filteredFournisseurs.map((fournisseur) => (
                  <Grid item xs={12} sm={6} md={4} key={fournisseur.id}>
                    <motion.div
                      variants={fadeInUp}
                      initial="initial"
                      animate="animate"
                      exit="exit"
                      layout
                    >
                      <StyledCard
                        onMouseEnter={() => setHoveredCard(fournisseur.id)}
                        onMouseLeave={() => setHoveredCard(null)}
                        sx={{
                          transform: hoveredCard === fournisseur.id ? 'translateY(-6px)' : 'none',
                        }}
                      >
                        <Box sx={{ p: 3 }}>
                          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                            <Badge
                              overlap="circular"
                              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                              badgeContent={
                                <Box
                                  sx={{
                                    width: 12,
                                    height: 12,
                                    bgcolor: fournisseur.facturesCount > 0 ? '#4caf50' : '#ff9800',
                                    borderRadius: '50%',
                                    border: '2px solid white',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                                  }}
                                />
                              }
                            >
                              <Avatar
                                sx={{
                                  width: 64,
                                  height: 64,
                                  bgcolor: genererCouleurDepuisChaine(fournisseur.name),
                                  fontSize: '1.8rem',
                                  fontWeight: 600,
                                  boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                                }}
                              >
                                {fournisseur.name?.charAt(0) || 'F'}
                              </Avatar>
                            </Badge>

                            <Box sx={{ flex: 1 }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <Box>
                                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#1A2B3C' }}>
                                    {fournisseur.name}
                                  </Typography>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                                    <Phone sx={{ fontSize: 14, color: '#9AA6B2' }} />
                                    <Typography variant="body2" sx={{ color: '#5F6B7A' }}>
                                      {fournisseur.numero}
                                    </Typography>
                                  </Box>
                                </Box>
                                <IconButton
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleMenuOpen(e, fournisseur);
                                  }}
                                  size="small"
                                  sx={{
                                    color: '#9AA6B2',
                                    '&:hover': { bgcolor: alpha('#667eea', 0.1), color: '#667eea' }
                                  }}
                                >
                                  <MoreHoriz />
                                </IconButton>
                              </Box>

                              <Divider sx={{ my: 2 }} />

                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <ReceiptLong sx={{ fontSize: 18, color: '#9AA6B2' }} />
                                  <Typography variant="body2" sx={{ color: '#5F6B7A' }}>
                                    {fournisseur.facturesCount || 0} factures
                                  </Typography>
                                </Box>
                                {fournisseur.totalMontant > 0 && (
                                  <Tooltip title={`Total: ${formatNumber(fournisseur.totalMontant)}`}>
                                    <Chip
                                      label={formatNumber(fournisseur.totalMontant)}
                                      size="small"
                                      sx={{
                                        bgcolor: alpha('#4CAF50', 0.1),
                                        color: '#4CAF50',
                                        fontWeight: 600,
                                        fontSize: '0.7rem'
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </Box>

                              {fournisseur.totalReste > 0 && (
                                <Box sx={{ mt: 1 }}>
                                  <Chip
                                    icon={<Warning sx={{ fontSize: 12 }} />}
                                    label={`Reste: ${formatNumber(fournisseur.totalReste)}`}
                                    size="small"
                                    sx={{
                                      bgcolor: alpha('#f44336', 0.1),
                                      color: '#f44336',
                                      fontWeight: 600,
                                      fontSize: '0.7rem',
                                      height: 20
                                    }}
                                  />
                                </Box>
                              )}

                            
                            </Box>
                          </Box>

                         
                        </Box>
                      </StyledCard>
                    </motion.div>
                  </Grid>
                ))}
              </AnimatePresence>
            </Grid>
          )}

          {/* Menu contextuel */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            TransitionComponent={Fade}
            PaperProps={{
              sx: {
                borderRadius: 2,
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                minWidth: 180
              }
            }}
          >
            <MenuItem onClick={() => preparerEditionFournisseur(fournisseurEnEdition)}>
              <ListItemIcon>
                <Edit fontSize="small" sx={{ color: '#667eea' }} />
              </ListItemIcon>
              <Typography variant="body2">Modifier</Typography>
            </MenuItem>
            <MenuItem onClick={() => {
              setDeleteDialog({
                open: true,
                id: fournisseurEnEdition?.id,
                name: fournisseurEnEdition?.name
              });
              handleMenuClose();
            }}>
              <ListItemIcon>
                <DeleteOutline fontSize="small" sx={{ color: '#f44336' }} />
              </ListItemIcon>
              <Typography variant="body2" sx={{ color: '#f44336' }}>Supprimer</Typography>
            </MenuItem>
          </Menu>

          {/* Facture Panel */}
        

          {/* Export Excel */}
          <motion.div variants={fadeInUp}>
            <Box sx={{ mt: 4 }}>
              <StyledCard>
                <Box sx={{ p: 3, textAlign: 'center' }}>
                  <Avatar sx={{ 
                    width: 64, 
                    height: 64, 
                    bgcolor: alpha('#4CAF50', 0.1),
                    color: '#4CAF50',
                    margin: '0 auto 16px'
                  }}>
                    <ImportExport sx={{ fontSize: 32 }} />
                  </Avatar>
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                    Exporter les Données
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#5F6B7A', mb: 3 }}>
                    Téléchargez la liste complète des fournisseurs au format Excel
                  </Typography>
                  <ExcelTableFournisseur data={fournisseurs} />
                </Box>
              </StyledCard>
            </Box>
          </motion.div>
        </motion.div>
      </Container>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialog.open}
        onClose={() => setDeleteDialog({ open: false, id: null, name: '' })}
        TransitionComponent={Zoom}
        PaperProps={{
          sx: {
            borderRadius: 4,
            width: 400,
            textAlign: 'center',
            overflow: 'hidden'
          }
        }}
      >
        <Box sx={{
          background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
          p: 3,
          textAlign: 'center'
        }}>
          <Avatar sx={{
            width: 70,
            height: 70,
            bgcolor: 'rgba(255,255,255,0.2)',
            margin: '0 auto 12px',
            border: '2px solid white'
          }}>
            <DeleteForever sx={{ fontSize: 40, color: 'white' }} />
          </Avatar>
          <Typography variant="h5" sx={{ color: 'white', fontWeight: 700, mb: 0.5 }}>
            Confirmer la suppression
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
            Cette action est irréversible
          </Typography>
        </Box>

        <DialogContent sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="body1" sx={{ mb: 2, color: '#1f2937' }}>
            Êtes-vous sûr de vouloir supprimer définitivement
          </Typography>
          <Chip
            label={deleteDialog.name}
            sx={{
              bgcolor: '#fee2e2',
              color: '#dc2626',
              fontWeight: 600,
              fontSize: '1rem',
              height: 36,
              px: 2,
              border: '1px solid #fecaca',
              mb: 3
            }}
          />
          <Typography variant="body2" sx={{ color: '#6b7280', fontStyle: 'italic' }}>
            Cette action supprimera toutes les factures associées à ce fournisseur
          </Typography>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 0, justifyContent: 'center', gap: 2 }}>
          <Button
            onClick={() => setDeleteDialog({ open: false, id: null, name: '' })}
            variant="outlined"
            startIcon={<Close />}
            sx={{
              borderRadius: 2,
              px: 3,
              py: 1,
              borderColor: '#d1d5db',
              color: '#6b7280',
              '&:hover': {
                borderColor: '#9ca3af',
                bgcolor: '#f9fafb'
              }
            }}
          >
            Annuler
          </Button>
          <Button
            onClick={supprimerFournisseur}
            variant="contained"
            color="error"
            startIcon={<DeleteForever />}
            sx={{
              borderRadius: 2,
              px: 3,
              py: 1,
              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
                transform: 'scale(1.02)'
              },
              transition: 'all 0.2s ease'
            }}
          >
            Supprimer
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialogue d'ajout/modification de fournisseur */}
      <Dialog 
        open={dialogueFournisseurOuvert} 
        onClose={reinitialiserFormulaireFournisseur}
        fullWidth
        maxWidth="sm"
        TransitionComponent={Zoom}
        PaperProps={{
          sx: {
            borderRadius: 4,
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle sx={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          py: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)' }}>
              {modeEdition ? <Edit /> : <Add />}
            </Avatar>
            <Box>
              <Typography variant="h6" fontWeight={700}>
                {modeEdition ? "Modifier le Fournisseur" : "Ajouter un Fournisseur"}
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.9 }}>
                {modeEdition ? "Mettez à jour les informations" : "Remplissez les informations ci-dessous"}
              </Typography>
            </Box>
          </Box>
          <IconButton onClick={reinitialiserFormulaireFournisseur} sx={{ color: 'white' }}>
            <Close />
          </IconButton>
        </DialogTitle>
        
        <DialogContent sx={{ py: 4, px: 3 }}>
            <br></br>
          <Grid container spacing={3}>
          
            <Grid item xs={12} sm={6}>
              
              <TextField
                fullWidth
                label="Nom du Fournisseur"
                value={nomFournisseur}
                onChange={(e) => setNomFournisseur(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Business sx={{ color: '#667eea' }} />
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: 2,
                    bgcolor: '#F5F7FA',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#667eea'
                    }
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Numéro de Téléphone"
                value={numeroFournisseur}
                onChange={(e) => setNumeroFournisseur(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Phone sx={{ color: '#667eea' }} />
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: 2,
                    bgcolor: '#F5F7FA',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#667eea'
                    }
                  }
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Adresse"
                multiline
                rows={2}
                value={addressFournisseur}
                onChange={(e) => setAddressFournisseur(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LocationOn sx={{ color: '#667eea' }} />
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: 2,
                    bgcolor: '#F5F7FA',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#667eea'
                    }
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="N° TVA"
                value={taxIdFournisseur}
                onChange={(e) => setTaxIdFournisseur(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountBalance sx={{ color: '#667eea' }} />
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: 2,
                    bgcolor: '#F5F7FA',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#667eea'
                    }
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel sx={{ color: '#5F6B7A' }}>Conditions de paiement</InputLabel>
                <Select
                  value={paymentTermsFournisseur}
                  onChange={(e) => setPaymentTermsFournisseur(e.target.value)}
                  label="Conditions de paiement"
                  sx={{
                    borderRadius: 2,
                    bgcolor: '#F5F7FA',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#667eea'
                    }
                  }}
                >
                  <MenuItem value="immediate">Paiement immédiat</MenuItem>
                  <MenuItem value="7_days">7 jours</MenuItem>
                  <MenuItem value="15_days">15 jours</MenuItem>
                  <MenuItem value="30_days">30 jours</MenuItem>
                  <MenuItem value="45_days">45 jours</MenuItem>
                  <MenuItem value="60_days">60 jours</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2, bgcolor: '#F5F7FA', justifyContent: 'space-between' }}>
          <Button 
            onClick={reinitialiserFormulaireFournisseur}
            variant="outlined"
            startIcon={<Cancel />}
            sx={{
              borderRadius: 2,
              px: 3,
              borderColor: '#BDBDBD',
              color: '#5F6B7A',
              '&:hover': {
                borderColor: '#9E9E9E',
                bgcolor: '#F5F5F5'
              }
            }}
          >
            Annuler
          </Button>
          <Button 
            onClick={handleSubmitFournisseur}
            variant="contained"
            startIcon={modeEdition ? <Save /> : <Add />}
            disabled={!nomFournisseur || !numeroFournisseur}
            sx={{
              borderRadius: 2,
              px: 4,
              background: 'linear-gradient(45deg, #667eea, #764ba2)',
              '&:hover': {
                background: 'linear-gradient(45deg, #5a67d8, #6b46a1)',
                transform: 'translateY(-2px)',
                boxShadow: '0 10px 20px rgba(102,126,234,0.3)'
              },
              '&:disabled': {
                background: '#E0E0E0'
              },
              transition: 'all 0.2s ease'
            }}
          >
            {modeEdition ? "Modifier" : "Enregistrer"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* CSS Animations */}
      <style jsx global>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
      `}</style>
    </Box>
  );
};

export default FournisseurPage;